import React, { useEffect } from 'react';
import './../../App.css';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import UploadAnimeComponent from './UploadComponent';

const UploadPage = () => {
    useEffect(() => {
        document.title = "Выгрузка";
    }, []);

    return (
        <PageShell className="upload-page">
            <PageHeader eyebrow="Инструменты" title="Загрузка серии" />
            <UploadAnimeComponent />
        </PageShell>
    );
};

export default UploadPage;
